import { gql } from "graphql-tag";

export const query = gql`
  query UnitDisclaimers($id: ID!) {
    interestList(id: $id) {
      br0Statement
      br1Statement
      br1DenStatement
      br2Statement
      br3Statement
      br4Statement
      br5Statement
      sharedStatement
    }
  }
`;

export const mutation = gql`
  mutation UpdateDisclaimers($id: ID!, $data: InterestListInput!) {
    updateInterestList(id: $id, data: $data) {
      id
    }
  }
`;
